import { createSlice } from "@reduxjs/toolkit";

// The Administrator nav - also the default/initial menuItem.
export const adminMenuItem = [
    {
      access: true,
      active: true,
      icon: "dashboard",
      key: "home",
      path: "dashboard",
      permission: {
        create: true,
        delete: true,
        edit: true,
        view: true,
      },
      subMenu: [],
      title: "Dashboard",
    },
    {
      access: true,
      active: false,
      icon: "course",
      key: "course",
      path: "course",
      permission: {
        create: true,
        delete: true,
        edit: true,
        view: true,
      },
      subMenu: [],
      title: "Course",
    },
    {
      access: true,
      active: false,
      icon: "courselist",
      key: "courselist",
      path: "courselist",
      permission: {
        create: true,
        delete: true,
        edit: true,
        view: true,
      },
      subMenu: [],
      title: "Course List",
    },
    {
      access: true,
      active: false,
      icon: "people",
      key: "people",
      path: "people",
      permission: {
        create: true,
        delete: true,
        edit: true,
        view: true,
      },
      subMenu: [],
      title: "People",
    },
    {
      access: true,
      active: false,
      icon: "group",
      key: "groups",
      path: "groups",
      permission: {
        create: true,
        delete: true,
        edit: true,
        view: true,
      },
      subMenu: [],
      title: "Group",
    },
    {
      access: true,
      active: false,
      icon: "report",
      key: "reports",
      path: "reports",
      permission: {
        create: true,
        delete: true,
        edit: true,
        view: true,
      },
      subMenu: [
        {
          access: true,
          icon: "people",
          key: "people",
          path: "account-report",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "People",
        },
        {
          access: true,
          icon: "course",
          key: "people",
          path: "people-report",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Course",
        },
        {
          access: true,
          icon: "group",
          key: "course",
          path: "course-report",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Group",
        },
        {
          access: true,
          icon: "coursetask",
          key: "course",
          path: "coursetask",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Course Tasks",
        },
        {
          access: true,
          icon: "activitylog",
          key: "course",
          path: "activitylog",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Activity Log",
        },
      ],
      title: "Reports",
    },
    {
      access: true,
      active: false,
      icon: "settings",
      key: "settings",
      path: "settings",
      permission: {
        create: true,
        delete: true,
        edit: true,
        view: true,
      },
      subMenu: [
        {
          access: true,
          icon: "account",
          key: "people",
          path: "settings-account",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Account",
        },
        {
          access: true,
          icon: "people",
          key: "course",
          path: "settings-people",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "People",
        },
        {
          access: true,
          icon: "course",
          key: "course",
          path: "settings-course",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Course",
        },
        {
          access: true,
          icon: "category",
          key: "courseTasks",
          path: "settings-category",
          permission: {
            create: true,
            view: true,
            delete: true,
            edit: true,
          },
          title: "Category",
        },
      ],
      title: "Settings",
    },
];

// The Tutor nav (Header's role switcher was a UI-only stub with no
// behavior; this is what selecting "Tutor" actually swaps menuItem to).
// Course/Group/Reports reuse the same real pages Administrator uses -
// Scoring/Conference/Calendar have no page built yet, so they route to
// a plain "coming soon" placeholder instead of a dead-end click.
export const tutorMenuItem = [
  {
    access: true,
    active: true,
    icon: "dashboard",
    key: "tutor-home",
    path: "tutor-dashboard",
    permission: { create: true, delete: true, edit: true, view: true },
    subMenu: [],
    title: "Dashboard",
  },
  {
    access: true,
    active: false,
    icon: "course",
    key: "tutor-course",
    path: "course",
    permission: { create: true, delete: true, edit: true, view: true },
    subMenu: [],
    title: "Course",
  },
  {
    access: true,
    active: false,
    icon: "group",
    key: "tutor-groups",
    path: "groups",
    permission: { create: true, delete: true, edit: true, view: true },
    subMenu: [],
    title: "Group",
  },
  {
    access: true,
    active: false,
    icon: "scoring",
    key: "tutor-scoring",
    path: "scoring",
    permission: { create: true, delete: true, edit: true, view: true },
    subMenu: [],
    title: "Scoring",
  },
  {
    access: true,
    active: false,
    icon: "conference",
    key: "tutor-conference",
    path: "conference",
    permission: { create: true, delete: true, edit: true, view: true },
    subMenu: [],
    title: "Conference",
  },
  {
    access: true,
    active: false,
    icon: "report",
    key: "tutor-reports",
    path: "reports",
    permission: { create: true, delete: true, edit: true, view: true },
    // Figma's Tutor Reports submenu only has Course/Course Tasks/Activity
    // Log - no People or Group, unlike Administrator's Reports.
    subMenu: [
      {
        access: true,
        icon: "course",
        key: "people",
        path: "people-report",
        permission: { create: true, view: true, delete: true, edit: true },
        title: "Course",
      },
      {
        access: true,
        icon: "coursetask",
        key: "course",
        path: "coursetask",
        permission: { create: true, view: true, delete: true, edit: true },
        title: "Course Tasks",
      },
      {
        access: true,
        icon: "activitylog",
        key: "course",
        path: "activitylog",
        permission: { create: true, view: true, delete: true, edit: true },
        title: "Activity Log",
      },
    ],
    title: "Reports",
  },
  {
    access: true,
    active: false,
    icon: "calendar",
    key: "tutor-calendar",
    path: "calendar",
    permission: { create: true, delete: true, edit: true, view: true },
    subMenu: [],
    title: "Calendar",
  },
];

// The Learner nav. There's no separate learner login anywhere in this
// app - the JWT is always the Owner/Admin session, with no concept of
// "the logged-in person is employee #4." So this isn't a real per-user
// portal; it's a "view as" mode - a person picker (see viewingAsPeopleId
// below) scopes My Course/Course List/Dashboard to a specific real
// person's real enrollment data, same session throughout. Calendar is
// reused as-is (org-wide, same as Tutor/Admin see) since conferences
// aren't queryable by attendee yet without a new backend endpoint.
export const learnerMenuItem = [
  {
    access: true,
    active: true,
    icon: "dashboard",
    key: "learner-home",
    path: "learner-dashboard",
    permission: { create: true, delete: true, edit: true, view: true },
    subMenu: [],
    title: "Dashboard",
  },
  {
    access: true,
    active: false,
    icon: "course",
    key: "learner-my-course",
    path: "my-course",
    permission: { create: true, delete: true, edit: true, view: true },
    subMenu: [],
    title: "My Course",
  },
  {
    access: true,
    active: false,
    icon: "courselist",
    key: "learner-course-list",
    path: "learner-course-list",
    permission: { create: true, delete: true, edit: true, view: true },
    subMenu: [],
    title: "Course List",
  },
  {
    access: true,
    active: false,
    icon: "scoring",
    key: "learner-my-scores",
    path: "my-scores",
    permission: { create: true, delete: true, edit: true, view: true },
    subMenu: [],
    title: "My Scores",
  },
  {
    access: true,
    active: false,
    icon: "calendar",
    key: "learner-calendar",
    path: "calendar",
    permission: { create: true, delete: true, edit: true, view: true },
    subMenu: [],
    title: "Calendar",
  },
];

const initialState = {
  menuItem: adminMenuItem,
  role: "Administrator",
  activeMenuList: [],
  isSideBarCollapsed: false,
  addGroupData: [],
  usersList: [],
  editUserData: {},
  editGroupData: {},
  initialLoader: true,
  getAllRequestData: [],
  getCreateAllCustomPeople: [],
  getCreateAllPeopleType: [],
  getCreateAllCourseMenu: [],
  // Which real person the Learner "view as" mode currently represents -
  // see learnerMenuItem's comment above for why this exists instead of
  // a real per-user login.
  viewingAsPeopleId: null,
  // Header.js fetches this once on mount and has no other way to learn the
  // logo changed - Settings > Account's save dispatches setOrgLogoUrl so
  // the header updates immediately instead of only after a hard refresh.
  orgLogoUrl: undefined,
};

export const systemSlice = createSlice({
  name: "systemSlice",
  initialState,
  reducers: {
    setInitialLoader: (state, action) => {
      return {
        ...state,
        initialLoader: action.payload,
      };
    },
    setViewingAsPeopleId: (state, action) => {
      return {
        ...state,
        viewingAsPeopleId: action.payload,
      };
    },
    setOrgLogoUrl: (state, action) => {
      return {
        ...state,
        orgLogoUrl: action.payload,
      };
    },
    setUsersList: (state, action) => {
      return {
        ...state,
        usersList: action.payload,
      };
    },
    setMenuItemData: (state, action) => {
      return {
        ...state,
        menuItem: action.payload,
      };
    },

    setRole: (state, action) => {
      return {
        ...state,
        role: action.payload,
      };
    },

    setActiveMenuList: (state, action) => {
      return {
        ...state,
        activeMenuList: action.payload,
      };
    },

    setIsSideBarCollapsed: (state, action) => {
      return {
        ...state,
        isSideBarCollapsed: action.payload,
      };
    },
    setEditUserData: (state, action) => {
      return {
        ...state,
        editUserData: action.payload,
      };
    },
    setEditGroupData: (state, action) => {
      return {
        ...state,
        editGroupData: action.payload,
      };
    },
    setAddGroupData: (state, action) => {
      return {
        ...state,
        addGroupData: action.payload,
      };
    },
    setGetAllRequestData: (state, action) => {
      return {
        ...state,
        getAllRequestData: action.payload,
      };
    },
    setGetCreateAllCustomPeople: (state, action) => {
      return {
        ...state,
        getCreateAllCustomPeople: action.payload,
      };
    },
    setGetCreateAllPeopleType: (state, action) => {
      return {
        ...state,
        getCreateAllPeopleType: action.payload,
      };
    },
    setGetCreateAllCourseMenu: (state, action) => {
      return {
        ...state,
        getCreateAllCourseMenu: action.payload,
      };
    },
  },
});

export const {
  setInitialLoader,
  setGetAllRequestData,
  setMenuItemData,
  setRole,
  setActiveMenuList,
  setIsSideBarCollapsed,
  setEditUserData,
  setAddGroupData,
  setUsersList,
  setEditGroupData,
  setGetCreateAllCustomPeople,
  setGetCreateAllPeopleType,
  setGetCreateAllCourseMenu,
  setViewingAsPeopleId,
  setOrgLogoUrl,
} = systemSlice.actions;

export const systemReducer = systemSlice.reducer;
